<ion-header id="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">Close<ion-icon slot="start" name="close-circle-outline"></ion-icon></ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button (click)="save()" [disabled]="!form.valid || !form.dirty">
        Save<ion-icon slot="end" name="save-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Rename Farm</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="light">
  <form [formGroup]="form">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item-group>
        <ion-item>
          <ion-input
            [required]="true"
            labelPlacement="stacked"
            placeholder="My new farm"
            inputmode="text"
            type="text"
            formControlName="name"
          >
            <div slot="label">Name:<ion-text color="danger">*</ion-text></div>
          </ion-input>
        </ion-item>
      </ion-item-group>
    </ion-list>
  </form>
</ion-content>
